import styled from 'styled-components'
import { Link } from 'gatsby'
import { FontLight, FontBold, Colors, Breakpoints } from './../../utils/variables'

export const StyledLink = styled(Link)`
    display: block;

    ${FontLight}
    font-size: 17px;
    letter-spacing: -0.25px;

    color: ${props => (props.theme === 'light') ? `${Colors.white}` : `${Colors.blue}`};
    text-decoration: none;

    @media screen and (min-width: ${Breakpoints.wide}) {
        font-size: 20px;
    }

    ${({ menuActive }) => menuActive && `
        color: ${Colors.blue};
    `}
`

export const Bold = styled.span`
    ${FontBold}
`